import * as React from 'react';
import { useChange } from '@deltasierra/react-hooks';
import { SelectOption, isSelectOption } from './common';
import { InputType, PuppetCheckedInputProps, PuppetCheckedInput } from './CheckedInput';

export type RadioButtonsInputProps = Omit<PuppetRadioButtonsInputProps, 'onChange' | 'value'> & {
    initialValue: string;
    onChange: (value: string) => void;
};

export const RadioButtonsInput: React.FC<RadioButtonsInputProps> = props => {
    const [value, setValue] = useChange<string>(props.initialValue, props.onChange);
    return <PuppetRadioButtonsInput {...props} value={value} onChange={event => setValue(event.target.value)} />;
};

export type PuppetRadioButtonsInputProps = Pick<PuppetCheckedInputProps, 'name' | 'onChange' | 'value'> & {
    options: Array<SelectOption | string>;
    type?: InputType;
};

export const PuppetRadioButtonsInput: React.FC<PuppetRadioButtonsInputProps> = ({ type = 'radio', ...props }) => {
    const cleanedOptions = props.options.map(option =>
        isSelectOption(option) ? option : { label: option, value: option },
    );
    return (
        <>
            {cleanedOptions.map((option, index) => (
                <PuppetCheckedInput
                    {...option}
                    checked={option.value === props.value}
                    key={index}
                    type="radio"
                    onChange={props.onChange}
                />
            ))}
        </>
    );
};
